/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { PCState } from '../../../core/enums';
import { CursorManager } from '../../../core/navigation';
import type { TivoPayloadAction } from '../../../core/tivo/tivo-redux-wrapper';
import { setPCSettingsFocusedPositionAction } from './parentalcontrols.actions';
import {
    SET_PC_MENU_OPTIONS,
    SET_PC_SETTING_VERTICAL_LIMIT,
    SET_PC_SETTINGS_HIGHLIGHT_POSITION,
    SET_PC_STATE,
} from './parentalcontrols.types';

interface IParentalControlsSettings {
    pcState: PCState | null;
    verticalLimit: number;
    verticalPosition: number;
    isFocused: boolean;
    menuOptions: Array<any>;
}

const initialState: IParentalControlsSettings = {
    pcState: null,
    verticalLimit: 0,
    verticalPosition: 0,
    isFocused: true,
    menuOptions: [],
};

const parentalControls = (
    state = initialState,
    { type, payload } = <TivoPayloadAction<IParentalControlsSettings>>{},
) => {
    switch (type) {
        case SET_PC_SETTING_VERTICAL_LIMIT:
            return {
                ...state,
                verticalLimit: payload.verticalLimit,
            };
        case SET_PC_STATE:
            return {
                ...state,
                pcState: payload.pcState,
            };
        case SET_PC_SETTINGS_HIGHLIGHT_POSITION:
            return {
                ...state,
                verticalPosition: payload.verticalPosition,
                isFocused: payload.isFocused,
            };
        case SET_PC_MENU_OPTIONS:
            return {
                ...state,
                menuOptions: payload.menuOptions,
            };
        default:
            return state;
    }
};

export const onCursorStateChangeParentalSettingsOperations =
    () => (dispatch: Function, getState: Function) => {
        const { verticalPosition } = getState().parentalControls;
        if (CursorManager.isCursorAppeared()) {
            dispatch(setPCSettingsFocusedPositionAction(verticalPosition, false));
        } else {
            dispatch(setPCSettingsFocusedPositionAction(verticalPosition, true));
        }
    };

export default parentalControls;
